import Money from "./Money";

export default {
  install(Vue) {
    Vue.filter("money", Money);
  },
};
